import React from "react";
import { Row, Col } from "react-bootstrap";
import LicensesTableRow from "js/components/account/account-table-license-row";
import { Navigation, Link, History } from "react-router";

export default React.createClass({
  getInitialState: function() {
    return {
      hideHeader: false,
      licenseError: ""
    }
  },

  handler(error) {
    this.setState({
        licenseError: error
    });
  },

  componentDidMount() {
    this.setState({hideHeader: window.innerWidth <= 760});
  },

  render: function() {

    return (
      <div>
        { this.props.canDownload &&
        <div><p>Download your FaceTec Production Keys below.  These Keys are your <Link to="/licensing?link=zoom-production-license-sftp-license-text-file">Key Text</Link> parameters when initializing the FaceTec SDKs in Production Mode.  <Link to="/licensing">Read more about Keys here</Link>.</p></div>
        }

        <hr />
        <div className="form-table full-width">
          { !this.state.hideHeader &&
          <div className="form-row form-header">
            <span className="form-label">
              Platform
            </span>
            <span className="form-value">
              Expiration
            </span>
            <span className="form-value">
              AppIDs/BundleIDs/Domains
            </span>
            <span className="form-value">
              Action
            </span>
          </div>
          }
          {this.props.dataSource.map(this.renderRow)}
        </div>
        {this.state.licenseError != "" ? <p className="error-message">{this.state.licenseError}</p> : "" }
      </div>
    );
  },
  renderRow: function(item) {
    var key = item.id + item.type;
    return <this.props.row {...item} key={key} appToken={this.props.appToken} action={this.handler} canDownload={this.props.canDownload} />;
  }
});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-license.jsx